import React from 'react';

import Banner from '../../components/anchorComponents/Banner';
import Bio from '../../components/anchorComponents/Bio';
import FeaturedSection from '../../components/anchorComponents/FeaturedSection';
import ContextualJoinOverlay from '../../components/generalComponents/ContextualJoinOverlay/ContextualJoinOverlay';


function AnchorPageComponents(props) {
  const {
    anchor,
    anchorsList,
    anchorId,
    anchorVideoUrl,
    chatService,
    chatServiceTem,
    extractIdFromSlug,
    fetchStreamDetails,
    guestUser,
    history,
    isBanned,
    toggleContextualJoinOverlay,
    showFanZone,
    slug,
    user,
    onNetworkError,
    totalVideosCount,
    totalPublicShowsCount,
    totalGalleriesCount,
    isImageLayout,
    galleriesAndVideosCount,
    anchorPortalCampaign,
    showOverlay,
    pageItemsShown,
    setBanStatus,
    setItemsCount,
    location,
    isSpotlighing,
    spotlighedAnchorUsername,
    spotlighedAnchorNickname,
    setNakedNewsLivePageAd,
    setNakedNewsLivePromoUrl,
  } = props;

  return (
    <>
      <Banner
        anchor={anchor}
        anchorId={anchorId}
        anchorVideoUrl={anchorVideoUrl}
        chatService={chatService}
        chatServiceTempted={chatServiceTem}
        extractIdFromSlug={extractIdFromSlug}
        fetchStreamDetails={fetchStreamDetails}
        guestUser={guestUser}
        history={history}
        isBanned={isBanned}
        openContextualOverlay={toggleContextualJoinOverlay}
        showFanZone={showFanZone}
        slug={slug}
        user={user}
        onNetworkError={onNetworkError}
        isSpotlighing={isSpotlighing}
        spotlighedAnchorUsername={spotlighedAnchorUsername}
        spotlighedAnchorNickname={spotlighedAnchorNickname}
      />
      <Bio
        anchor={anchor}
        authenticated={user.authenticated}
        extractIdFromSlug={extractIdFromSlug}
        galleriesAndVideosCount={galleriesAndVideosCount}
        history={history}
        isImageLayout={isImageLayout}
        loggedInUsername={user.user ? user.user.username : ''}
        openContextualOverlay={toggleContextualJoinOverlay}
        promoThumbnail={anchor.fanzonePromopic}
        promoVideo={anchor.promoClip}
        totalGalleriesCount={totalGalleriesCount}
        totalPublicShowsCount={totalPublicShowsCount}
        totalVideosCount={totalVideosCount}
        user={user}
      />

      <ContextualJoinOverlay
        anchorId={anchorId}
        anchorPortalCampaign={anchorPortalCampaign}
        anchorShortUrl={slug}
        closeContextualOverlay={toggleContextualJoinOverlay}
        history={history}
        setNakedNewsLivePromoUrl={setNakedNewsLivePromoUrl}
        showOverlay={showOverlay}
        user={user}
      />
      <FeaturedSection
        anchorName={anchor.name}
        anchorShortUrl={slug}
        anchorUsername={anchor.username}
        anchors={anchorsList}
        extractIdFromSlug={extractIdFromSlug}
        galleriesAndVideosCount={galleriesAndVideosCount}
        id={anchorId}
        location={location}
        pageItemsShown={pageItemsShown}
        setBanStatus={setBanStatus}
        setItemsCount={setItemsCount}
        showClipStore={anchor.showClipStore}
        showFanZone={showFanZone}
        user={user}
      />

    </>
  );
}

export default AnchorPageComponents;
